import { j as s, c as A } from "../../utils-BdNIfrGQ.js";
import * as c from "react";
import L from "react";
import { c as P, a as G, b as H, u as K, P as O } from "../../index-wif4gfZf.js";
import { u as _ } from "../../index-DLcqcWxM.js";
import { P as U, D as V } from "../../index-B9Qoa2iP.js";
import { h as W, R as Z, u as q, F as B } from "../../Combination-CNeqR4sO.js";
import { u as J } from "../../index-Cv867SGx.js";
import { c as j, C as Q, R as X, A as w, a as Y } from "../../index-NCB3MGjP.js";
import { P as b } from "../../index-BpWB3aFK.js";
import { n as ee } from "../../normalize-spacing-DY0KSpr_.js";
var x = "Popover", [E] = G(x, [
  j
]), m = j(), [oe, l] = E(x), N = (e) => {
  const {
    __scopePopover: n,
    children: t,
    open: a,
    defaultOpen: o,
    onOpenChange: r,
    modal: i = !1
  } = e, p = m(n), f = c.useRef(null), [v, g] = c.useState(!1), [h, u] = K({
    prop: a,
    defaultProp: o ?? !1,
    onChange: r,
    caller: x
  });
  return /* @__PURE__ */ s.jsx(X, { ...p, children: /* @__PURE__ */ s.jsx(
    oe,
    {
      scope: n,
      contentId: J(),
      triggerRef: f,
      open: h,
      onOpenChange: u,
      onOpenToggle: c.useCallback(() => u((C) => !C), [u]),
      hasCustomAnchor: v,
      onCustomAnchorAdd: c.useCallback(() => g(!0), []),
      onCustomAnchorRemove: c.useCallback(() => g(!1), []),
      modal: i,
      children: t
    }
  ) });
};
N.displayName = x;
var y = "PopoverAnchor", te = c.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...a } = e, o = l(y, t), r = m(t), { onCustomAnchorAdd: i, onCustomAnchorRemove: p } = o;
    return c.useEffect(() => (i(), () => p()), [i, p]), /* @__PURE__ */ s.jsx(w, { ...r, ...a, ref: n });
  }
);
te.displayName = y;
var F = "PopoverTrigger", S = c.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...a } = e, o = l(F, t), r = m(t), i = _(n, o.triggerRef), p = /* @__PURE__ */ s.jsx(
      O.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": I(o.open),
        ...a,
        ref: i,
        onClick: P(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? p : /* @__PURE__ */ s.jsx(w, { asChild: !0, ...r, children: p });
  }
);
S.displayName = F;
var R = "PopoverPortal", [re, ne] = E(R, {
  forceMount: void 0
}), D = (e) => {
  const { __scopePopover: n, forceMount: t, children: a, container: o } = e, r = l(R, n);
  return /* @__PURE__ */ s.jsx(re, { scope: n, forceMount: t, children: /* @__PURE__ */ s.jsx(b, { present: t || r.open, children: /* @__PURE__ */ s.jsx(U, { asChild: !0, container: o, children: a }) }) });
};
D.displayName = R;
var d = "PopoverContent", M = c.forwardRef(
  (e, n) => {
    const t = ne(d, e.__scopePopover), { forceMount: a = t.forceMount, ...o } = e, r = l(d, e.__scopePopover);
    return /* @__PURE__ */ s.jsx(b, { present: a || r.open, children: r.modal ? /* @__PURE__ */ s.jsx(se, { ...o, ref: n }) : /* @__PURE__ */ s.jsx(ce, { ...o, ref: n }) });
  }
);
M.displayName = d;
var ae = H("PopoverContent.RemoveScroll"), se = c.forwardRef(
  (e, n) => {
    const t = l(d, e.__scopePopover), a = c.useRef(null), o = _(n, a), r = c.useRef(!1);
    return c.useEffect(() => {
      const i = a.current;
      if (i) return W(i);
    }, []), /* @__PURE__ */ s.jsx(Z, { as: ae, allowPinchZoom: !0, children: /* @__PURE__ */ s.jsx(
      T,
      {
        ...e,
        ref: o,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: P(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), r.current || t.triggerRef.current?.focus();
        }),
        onPointerDownOutside: P(
          e.onPointerDownOutside,
          (i) => {
            const p = i.detail.originalEvent, f = p.button === 0 && p.ctrlKey === !0, v = p.button === 2 || f;
            r.current = v;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: P(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), ce = c.forwardRef(
  (e, n) => {
    const t = l(d, e.__scopePopover), a = c.useRef(!1), o = c.useRef(!1);
    return /* @__PURE__ */ s.jsx(
      T,
      {
        ...e,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          e.onCloseAutoFocus?.(r), r.defaultPrevented || (a.current || t.triggerRef.current?.focus(), r.preventDefault()), a.current = !1, o.current = !1;
        },
        onInteractOutside: (r) => {
          e.onInteractOutside?.(r), r.defaultPrevented || (a.current = !0, r.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = r.target;
          t.triggerRef.current?.contains(i) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && o.current && r.preventDefault();
        }
      }
    );
  }
), T = c.forwardRef(
  (e, n) => {
    const {
      __scopePopover: t,
      trapFocus: a,
      onOpenAutoFocus: o,
      onCloseAutoFocus: r,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: p,
      onPointerDownOutside: f,
      onFocusOutside: v,
      onInteractOutside: g,
      ...h
    } = e, u = l(d, t), C = m(t);
    return q(), /* @__PURE__ */ s.jsx(
      B,
      {
        asChild: !0,
        loop: !0,
        trapped: a,
        onMountAutoFocus: o,
        onUnmountAutoFocus: r,
        children: /* @__PURE__ */ s.jsx(
          V,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: g,
            onEscapeKeyDown: p,
            onPointerDownOutside: f,
            onFocusOutside: v,
            onDismiss: () => u.onOpenChange(!1),
            children: /* @__PURE__ */ s.jsx(
              Q,
              {
                "data-state": I(u.open),
                role: "dialog",
                id: u.contentId,
                ...C,
                ...h,
                ref: n,
                style: {
                  ...h.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), k = "PopoverClose", ie = c.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...a } = e, o = l(k, t);
    return /* @__PURE__ */ s.jsx(
      O.button,
      {
        type: "button",
        ...a,
        ref: n,
        onClick: P(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
ie.displayName = k;
var pe = "PopoverArrow", le = c.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...a } = e, o = m(t);
    return /* @__PURE__ */ s.jsx(Y, { ...o, ...a, ref: n });
  }
);
le.displayName = pe;
function I(e) {
  return e ? "open" : "closed";
}
var ue = N, de = S, fe = D, $ = M;
const ve = ue, Pe = de, z = c.forwardRef(({ className: e, align: n = "center", sideOffset: t = 4, ...a }, o) => /* @__PURE__ */ s.jsx(fe, { children: /* @__PURE__ */ s.jsx(
  $,
  {
    ref: o,
    align: n,
    sideOffset: t,
    className: A(
      "z-50 w-[228px] rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin]",
      e
    ),
    ...a
  }
) }));
z.displayName = $.displayName;
const me = L.forwardRef(
  ({ trigger: e, children: n, spacing: t, ...a }, o) => /* @__PURE__ */ s.jsxs(ve, { ...a, children: [
    /* @__PURE__ */ s.jsx(Pe, { asChild: !0, children: e }),
    /* @__PURE__ */ s.jsx(z, { ref: o, className: A(ee(t)), children: n })
  ] })
);
me.displayName = "Popover";
export {
  me as default
};
